<template>
  <div class="search-result-page">
    <go-back class="go-back"></go-back>
    <div class="container">
      <div class="title">
        {{searchContent}}
      </div>
      <div class="news-list">
        <div class="news-list-content" v-loading="isLoading">
          <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
            <news-list-item v-for="(item, idx) in resultData" :key="idx" :data="item"></news-list-item>
          </div>
        </div>
        <div class="loading" v-if="pageItems && resultData.length"><div class="loading-word">加载中...</div></div>
        <div class="loading" v-if="!pageItems"><div class="loading-word">没有更多了</div></div>
        <div class="no-data-container" v-if="!isLoading && !resultData.length">
          <no-data></no-data>
        </div>
      </div>
    </div>
    <BackTop></BackTop>
  </div>
</template>

<script>
import BackTop from '@/components/common/BackTop';
import QuestionQuery from '@/rest/questionQuery';
import NewsListItem from '@/components/news-monitor/NewsListItem';
import NoData from '@/components/common/NoData';
import GoBack from '@/components/common/GoBack'; 

export default {
  data() {
    return {
      resultData: [],
      loading: false,
      pageNum: 1,
      pageSize: 10,
      busy: false,
      searchContent: '',
      pageItems: [],
      isLoading: false,
      timer: null
    };
  },
  methods: {
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.pageNum++;
        this.getSearch(true);
      }, 300);
    },
    getSearch() {
      this.isLoading = true;
      QuestionQuery.getSearchData(this.pageNum, this.pageSize, this.searchContent).then(result => {
        this.isLoading = false;
        if (result.pageItems) {
          this.pageItems = result.pageItems;
          this.resultData = this.resultData.concat(result.pageItems);
          this.busy = false;
        } else {
          this.pageItems = result.pageItems;
          this.busy = true;
        }
      });
    }
  },
  computed: {
    disabled() {
      return this.loading;
    }
  },
  components: {
    NewsListItem,
    BackTop,
    NoData,
    GoBack
  },
  mounted() {
    this.searchContent = this.$route.query.hot_words || '';
    this.getSearch();
  }
};
</script>

<style lang="scss" scoped>
.loading {
  height: 10px;
  width: 1000px;
  color: #ffffff99;
  background: #343239;
  .loading-word {
    margin: 0 auto;
    width: 200px;
  }
}
  .search-result-page {
    width: 100%;
    min-width: 1000px;
    min-height: 100%;
    background: #343239;
    .go-back {
      position: fixed;
      left: 32px;
      top: 96px;
    }
    .container {
      margin: 0 auto;
      width: 1000px;
      .title {
        padding: 24px 0 12px;
        color: #ffffff;
        font-size: 24px;
      }
      .news-list {
        padding-top: 12px;
        padding-bottom: 12px;
        .no-data-container {
          height: 500px;
        }
        .news-list-content {
          overflow: hidden;
          border-radius: 8px;
          background-color: #3e3c42;
        }
        ul {
          padding-left: 0;
          margin: 0;
        }
        li {
          list-style: none;
        }
      }
    }
  }
</style>

